import script from "./MsgTypeComp.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgTypeComp.vue?vue&type=script&setup=true&lang=js"

import "./MsgTypeComp.vue?vue&type=style&index=0&id=3342e3dc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3342e3dc"]])

export default __exports__